// Base URL for all API calls. In production the UI is served by the Express API on the
// same origin, so a relative '/api' is enough. Override with REACT_APP_API_BASE_URL
// (see .env.development for local development against the API on :4000).
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '/api';
